import { ReactNode, useState } from 'react';
import { alpha, Box, useTheme } from '@mui/material';

import { useInvoiceDetailStore, useResponsive, useSubscriptionDetailsStore } from '@zeta-core';
import { DASHBOARD_CONFIG } from '../common/constants';
import { DashboardLayout } from '../dashboard-layout';
import DashboardContainer from '../dashboard-layout/dashboard-container';
import ProfileSetupNavigation from './profile-setup-navigation';
import { useFlexiblePlanAccess } from '../../hooks/use-flexible-plan-access';

interface IFactFindLayoutType {
  children: ReactNode;
}

const ProfileSetupLayout = ({ children }: IFactFindLayoutType) => {
  const theme = useTheme();
  const currentSubscription = useSubscriptionDetailsStore((state) => state.subscription);
  const subscriptionSuspended = useInvoiceDetailStore((state) => state.suspended);
  const [stretch, setStretch] = useState(true);
  const lgUp = useResponsive('up', 'lg');
  const { hasFlexiblePlanAccess } = useFlexiblePlanAccess();

  const disableNavOptions = () => {
    return !hasFlexiblePlanAccess || subscriptionSuspended || currentSubscription?.initialPaymentPending;
    // return false;
  };

  return (
    <DashboardLayout hideNavOptions={disableNavOptions()}>
      <ProfileSetupNavigation stretch={stretch && lgUp} setStretch={setStretch} disableNavOptions={disableNavOptions()} />
      <DashboardContainer sx={{ ml: stretch && lgUp ? DASHBOARD_CONFIG.NAVIGATION.DESKTOP_WIDTH / 8 : 0 }} variant="sm">
        <Box
          sx={{
            '& .MuiDataGrid-root': {
              bgcolor: 'background.paper',
            },
            '& .MuiDataGrid-columnHeaders': {
              bgcolor: alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.06 : 0.035),
              borderBottom: `1px solid ${theme.palette.divider}`,
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              color: theme.palette.text.primary,
              fontWeight: 700,
            },
            '& .MuiDataGrid-columnSeparator': {
              display: 'none',
            },
            '& .MuiDataGrid-footerContainer': {
              borderTop: `1px solid ${theme.palette.divider}`,
              bgcolor: alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.03 : 0.015),
            },
          }}
        >
          {children}
        </Box>
      </DashboardContainer>
    </DashboardLayout>
  );
};

export default ProfileSetupLayout;
